import classes from './StartingPageContent.module.css';

const StartingPageContent = () => {
  return (
    <section className={classes.starting}>
      <h1>Welcome Page</h1>
    </section>
  );
};

export default StartingPageContent;
